import {isNumber} from "lodash";

export const getMetaPage = (page?: number) => {
    return isNumber(page) && page > 1 ? ` - strona ${page}` : "";
};
